var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvironmentallyValuableOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13C13.1569 13 14.5 11.6569 14.5 10C14.5 8.34315 13.1569 7 11.5 7C9.84314 7 8.5 8.34315 8.5 10C8.5 11.6569 9.84314 13 11.5 13Z",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1H11.5C4 1 1 4 1 11.5V20.5C1 28 4 31 11.5 31H20.5C28 31 31 28 31 20.5V14.5",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1715 5.65689C21.6715 4.09975 22.2572 2.17118 23.8858 1.64261C24.7429 1.36403 25.8072 1.59975 26.4072 2.42832C26.9715 1.56403 28.0644 1.37118 28.9215 1.64261C30.5572 2.17118 31.1429 4.09975 30.6429 5.65689C29.8644 8.12118 27.1644 9.40689 26.4072 9.40689C25.6501 9.40689 22.9715 8.14975 22.1715 5.65689Z",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26.4286L9.38571 21.4714C10.5786 20.6714 12.2786 20.7571 13.3429 21.6786L13.8429 22.1071C15.0143 23.1071 16.9071 23.1071 18.0786 22.1071L24.3214 16.75C25.4929 15.75 27.3857 15.75 28.5571 16.75L31 18.85",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentallyValuableOff);
export default __webpack_public_path__ + "static/media/environmentally_valuable_off.40e00b2f17f3036ddfe653a606da0706.svg";
export { ForwardRef as ReactComponent };